import { IPalabrasAgrovocWs } from "../interfaces/Workspace"
import { getQueryParameter } from "../util/helpers";
import { get } from "./fetch"


export const getPalabrasLogros = async (queryParameters:{idioma?:string, paisId?:string}): Promise<IPalabrasAgrovocWs[]> => {
    let queryString = getQueryParameter(queryParameters);
    var palabrasWs:IPalabrasAgrovocWs[] = await get(`/api/palabras-logros${queryString}`)
    return palabrasWs
}

export const getPalabrasIniciativas = async (queryParameters:{idioma?:string, paisId?:string}): Promise<IPalabrasAgrovocWs[]> => {
    let queryString = getQueryParameter(queryParameters);
    var palabrasIniciativas:IPalabrasAgrovocWs[] = await get(`/api/palabras-iniciativas${queryString}`)
    return palabrasIniciativas
}

export const getPalabrasIniciativasRegionales = async (queryParameters:{idioma?:string, paisId?:string}): Promise<IPalabrasAgrovocWs[]> => {
    let queryString = getQueryParameter(queryParameters);
    var palabrasIniciativas:IPalabrasAgrovocWs[] = await get(`/api/palabras-iniciativas/iniciativas-regionales${queryString}`)
    return palabrasIniciativas
}